<template>


    <div class="modal is-active"  v-on:keyup.enter="saveChange"  v-on:keyup.esc="closeBtn"  >
        <div class="modal-background"></div>
        <div class="modal-card">
            <header class="modal-card-head">
                <p class="modal-card-title">Add to Favorites?</p>
                <button class="delete" aria-label="close"   @click="closeBtn" ></button>
            </header>
            <section class="modal-card-body">
                <!--                  content-->
                <b-table :data="dataPrePareAddtoFav" :columns="columns"></b-table>
            </section>
            <footer class="modal-card-foot">
                <button class="button is-success"   ref="fname" @click="saveChange"  >Save changes</button>
                <button class="button"   @click="closeBtn" >Cancel</button>
            </footer>
        </div>
    </div>

</template>

<script>
    /* eslint-disable no-console */
    export default {
        name: "DlgConfirmToAddOPDToFav",
        mounted() {
            // console.log(this.dataToChild)
            //clear again
            this.dataPrePareAddtoFav = []
            this.dataToChild.forEach( element => {
                var tmp =    { 'idlab': element.idlab ,'kind': element.kind , 'idopd': element.idopd, 'opdname': element.opdname, 'owner_name': element.owner_name,  'gender': element.gender }
                this.dataPrePareAddtoFav.push(tmp)
            })

            this.$refs.fname.focus()
        },
        props:{
            dataToChild : Array ,
        },
        methods:{
            closeBtn(){
                this.$emit('close')
            },
            saveChange(){
                this.$emit('closeWithChange',this.dataPrePareAddtoFav)
                this.$emit('close')
            }
        },
        data() {
            return {
                dataPrePareAddtoFav: [
                    {'idlab':"" , 'kind': "",'idopd': "", 'opdname': '', 'owner_name': '',  'gender': '' },

                ],
                columns: [
                    {
                        field: 'idlab',
                        label: 'Lab No.',
                    },
                    {
                        field: 'idopd',
                        label: 'OPD No.',
                    },
                    {
                        field: 'opdname',
                        label: 'OPD Name.',
                    },
                    {
                        field: 'owner_name',
                        label: 'Owner Name.',
                    },
                    {
                        field: 'gender',
                        label: 'Gender.',
                    },
                ]
            }
        }
    }
</script>

<style scoped>

</style>